const MAX_LENGTH = 40;

export function truncateProductName(name: string): string {
  // Cut at first comma
  const beforeComma = name.split(",")[0].trim();
  // Truncate if still too long
  if (beforeComma.length <= MAX_LENGTH) return beforeComma;
  return beforeComma.slice(0, MAX_LENGTH).trimEnd() + "...";
}
